<template>
    <div class="border border-gray flex rounded-md has-[:checked]:border-gray-800 has-[:checked]:ring-1 has-[:checked]:ring-gray-800 has-[:disabled]:border-gray-200 dark:border-gray-675 dark:has-[:checked]:border-gray dark:has-[:checked]:ring-gray hover:border-gray-800 dark:hover:border-gray">
        <label class="p-5 min-w-0 flex gap-2 grow items-center has-[:disabled]:opacity-25 has-[:disabled]:pointer-events-none">
            <input
                type="radio"
                :name="name"
                :value="option.attributes.value"
                :disabled="disabled"
                :checked="checked"
                @change="emit('change')"
                class="peer sr-only"
            />
            <BaseSvg name="CheckOutlined" aria-hidden="true" class="bg-gray-275 fill-gray-275 rounded-full shrink-0 size-5 peer-checked:bg-blue-650 peer-checked:fill-white dark:bg-gray-675 dark:fill-gray-675"/>
            <span class="max-w-full text-gray text-sm truncate peer-checked:text-gray-800 dark:text-gray-425 dark:peer-checked:text-white">
                <b v-if="option.attributes.value" class="inline-block mr-1 text-gray-800 dark:text-white">{{ option.attributes.value }}</b>
                <span v-if="option.attributes.label !== option.attributes.value">{{ option.attributes.label }}</span>
            </span>
        </label>
        <button type="button" class="group p-5 pl-0" @click="emit('preview')" v-if="option.attributes.description || option.attributes.image">
            <div class="bg-gray shrink-0 flex group items-center justify-center rounded-full size-6 group-hover:bg-gray-800 dark:bg-gray-275 dark:group-hover:bg-white">
                <BaseSvg name="Preview" class="fill-white size-4 dark:fill-gray-800 dark:group-hover:fill-gray-800" aria-hidden="true"/>
                <span class="sr-only">View {{ option.attributes.value }} detail</span>
            </div>
        </button>
    </div>
</template>
<script setup>
const emit = defineEmits(['preview'])

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    option: {
        type: Object,
        required: true,
    },
    checked: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})
</script>
